import propertyForm from './propertyForm'

export default {
  propertyForm
}